// @flow

const isEmpty = (obj): boolean =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length;

export default isEmpty;
